import React, { useEffect } from 'react';
import { SubContainer } from '../../shared/components/layout_components/sub_container/styles';
import { Container } from '../../shared/components/layout_components/container/styles';

const CadastroPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Cadastro';
  }, []);

  return (
    <Container>
      <SubContainer flex={4}></SubContainer>
    </Container>
  );
};

export { CadastroPage };
